export default "https://cdn-static.gokick.com/assets/3258f73df43fa954b49bc6bd6de466cccdb5fe2c/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";